import DynamicPlaylist from "./DynamicPlaylist";
import { AddToHistory } from "./types";
var PlaybackHistory = /** @class */ (function () {
    function PlaybackHistory() {
        this._internalList = new DynamicPlaylist([], {
            history_mode: AddToHistory.LOCAL_ONLY
        }, 'history', false);
    }
    PlaybackHistory.getInstance = function () {
        if (PlaybackHistory.instance) {
            return PlaybackHistory.instance;
        }
        PlaybackHistory.instance = new PlaybackHistory();
        return PlaybackHistory.getInstance();
    };
    // Getters
    PlaybackHistory.prototype.getTracks = function () {
        return this._internalList.tracks();
    };
    // Modification
    PlaybackHistory.prototype.addTrack = function (track) {
        this._internalList.pop(track);
        var tracks = [{
                album: track.album,
                track: track.track,
                playbackInfo: track.playbackInfo
            }].concat(this._internalList.tracks());
        this._internalList.replace(tracks.slice(0, 20));
    };
    PlaybackHistory.prototype.appendTracks = function (tracks) {
        this._internalList.appendTracks(tracks);
    };
    PlaybackHistory.prototype.removeTrack = function (track) {
        this._internalList.pop(track);
    };
    // Listeners
    PlaybackHistory.prototype.addChangeHandler = function (handler) {
        return this._internalList.addChangeHandler(handler);
    };
    PlaybackHistory.prototype.removeChangeHandler = function (id) {
        this._internalList.removeChangeHandler(id);
    };
    return PlaybackHistory;
}());
export default PlaybackHistory;
//# sourceMappingURL=PlaybackHistory.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/player/PlaybackHistory.js
// module id = 440
// module chunks = 0